export default String.raw`
{% assign showDeposit = false -%}
{% for product in customer.Cart.Products -%}
	{% if product.DepositValue > 0 -%}
		{% assign showDeposit = true -%}
	{% endif -%}
	{% if product.BasicUnit == null -%}
		{% assign productUnits = product.SaleUnit -%}
	{% else -%}
		{% assign productUnits = product.BasicUnit -%}
	{% endif -%}
{% endfor -%}

<div class="header__sidebar {% unless include == 'showSmallInquiry' -%} hide none {% endunless -%} header-sidebar-js header-inquiry-sidebar-js">
    <div class="header__sidebar-content right header-sidebar-content-js {% unless include == 'showSmallInquiry' -%} hide {% endunless -%} header-cart">
        <div class="header__sidebar-header">
            <div class="header-cart__name-box">
                <div class="header-cart__name small-cart-name-js">
                    <p class="header-cart__name-text">
						{{translations.Inquiry}}{% if inquiryExists -%}: <span class="inquiry-name-to-replace-js"></span>{% endif -%}
                    </p>
                </div>
            </div>

            <button class="header__sidebar-closer header-sidebar-closer-js" aria-label="{{ translations.Close }}">
                <svg aria-hidden="true">
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
                </svg>
            </button>

			{% if inquirySize > 0 -%}
				<div class="header-cart__change {% if inquirySize > 0 -%} hidden-js {% endif -%}">
					<button class="header-cart__change-btn toggle-small-cart-change-popup-js">
						<svg>
							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#exchange-{{settings.iconStyle}}"></use>
						</svg>
						<span>{{translations.ChangeInquiry}}</span>
						<div class="loader-js loader hidden-js"></div>
					</button>
					<div class="header-cart__change-list small-cart-change-popup-js hidden-js">
                        <ul>
                            {% for oneOfCart in customer.Carts -%}
                                {% if oneOfCart.Inquiry -%}
                                    <li class="header-cart__change-item change-inquiry-link-js" data-id="{{oneOfCart.Id}}" data-count="{{oneOfCart.Count}}">
                                        <span>{{translations.Inquiry}} <span class="index-js">{{forloop.index}}</span></span>
                                    </li>
                                {% endif -%}
                            {% endfor -%}
                        </ul>
					</div>
				</div>
			{% endif -%}
        </div>
        <div class="header-cart__content">
			{% assign inquiryProductsSize = customer.Cart.Products | Size -%}

			{% assign maxInputQuantityValue = 99999 -%}

			{% if stockLevel and stockLevel.QuantityControl -%}
				{% if noSupplyProductOnControlledStock -%}
					{% assign max = maxInputQuantityValue -%}
				{% else -%}
					{% capture max -%}{{ stockValue }}{% endcapture -%}
				{% endif -%}
				{% if stockValue == "0" or stockValue == 0 -%}
					{% assign min = 0 -%}
					{% if config.Products.DecimalUnits -%}
						{% capture min -%}0{{ config.DecimalSeparator }}00{% endcapture -%}
					{% endif -%}
				{% elseif config.Products.DecimalUnits == false -%}
					{% assign min = 1 -%}
				{% else -%}
					{% capture min -%}0{{ config.DecimalSeparator }}01{% endcapture -%}
				{% endif -%}
			{% elseif config.Products.DecimalUnits == false -%}
				{% assign max = maxInputQuantityValue -%}
				{% assign min = 1 -%}
			{% else -%}
				{% assign max = maxInputQuantityValue -%}
				{% capture min -%}0{{ config.DecimalSeparator }}01{% endcapture -%}
			{% endif -%}

			{% assign inquiryExists = false -%}
			{% assign cartExists = false -%}
			{% assign inquirySize = 0 -%}
			{% assign cartSize = 0 -%}
			{% for oneOfCart in customer.Carts -%}
				{% if oneOfCart.Inquiry -%}
					{% assign inquiryExists = true -%}
					{% assign inquirySize = inquirySize | Plus: 1 -%}
				{% else -%}
					{% assign cartExists = true -%}
					{% assign cartSize = cartSize | Plus: 1 -%}
				{% endif -%}
			{% endfor -%}

			{% if inquirySize == 0 and customer.Cart.Inquiry and customer.Cart.Products[0] -%}
				{% assign inquiryExists = true -%}
				{% assign inquirySize = inquirySize | Plus: 1 -%}
			{% elsif cartSize == 0 and customer.Cart.Products[0] -%}
				{% assign cartExists = true -%}
				{% assign cartSize = cartSize | Plus: 1 -%}
			{% endif -%}

			{% assign inquiryActive = false -%}
			{% if customer.Cart.Inquiry and config.B2B -%}
				{% assign inquiryActive = true -%}
			{% endif -%}

			{% if inquiryActive and page.PageId == config.DefinedPages.Order.Id -%}
				{% assign inquiryActiveOnCartPage = true -%}
			{% endif -%}

			{% if inquiryProductsSize > 0 -%}
				<div class="header-cart__list">
					<input type="hidden" class="cartItemsList-cartId-js" value="{{config.DefinedPages.Order.Id}}">
					<input type="hidden" class="cartItemsList-cartValue-js" value="{{ customer.Cart.TotalValue }}">
					<input type="hidden" class="cartItemsList-firstOpening-js" value="true">

					<div class="header-cart__list-row first">
						<div class="header-cart__list-column product">{{translations.Product}}</div>
						<div class="header-cart__list-column quantity-col">{{translations.Quantity}}</div>
						<div class="header-cart__list-column price">
							{{translations.Price}}
							{% if customer.Cart.SubtotalPrices -%}
								{{ translations.Netto | Downcase }}
							{% else -%}
								{{ translations.Brutto | Downcase }}
							{% endif -%}
						</div>
					</div>

					{% for product in customer.Cart.Products -%}
							{% if product.IsSetElement -%}
								{% if product.IsSetParent -%}
									{% if config.ENTERPRISE -%}
										{% assign setValue = product.TotalPrice | Minus: product.TotalPrice -%}
									{% else -%}
										{% assign setValue = product.Price | Minus: product.Price -%}
									{% endif -%}
									{% assign loopStart = forloop.index0 -%}
									{% assign loopEnd = customer.Cart.Products | Size | Minus: 1 -%}
									{% assign setCounter = 0 -%}
									{% for setElIndex in (loopStart..loopEnd) -%}
										{% assign setEl = customer.Cart.Products[setElIndex] -%}
										{% if setEl.IsSetElement == false or (setEl.IsSetParent and setElIndex > loopStart) -%}
											{% break -%}
										{% else -%}
											{% assign setCounter = setCounter | Plus: 1 -%}
										{% endif -%}
										{% assign setValue = setValue | Plus: setEl.Price -%}
									{% endfor -%}

									<div class="header-cart__list-row setParent-js form-js" data-set-elements="{{setCounter}}" data-number="{{product.No}}" data-id="{{product.Id}}" data-name="{{ product.SetName }}" data-price="{{ setValue }}" data-quantity="1">
														
										<a href="{{ page.BaseHref }}{{ product.Url }}" title="{{ translations.Set | Capitalize }}" class="header-cart__list-column product">
											<div class="header-cart__list-image">
												{% if product.Image.Id > 0 and product.Image.Link != null -%}
													<img src="img/{{ product.Image.Id }}/{{ product.Image.Link }}" alt="{{ product.Name }}" loading="eager" fetchpriority="high">
												{% elsif product.Image.ExternalUrl != null -%}
													<img src="{{ product.Image.ExternalUrl }}" alt="{{ product.Name }}" loading="eager" fetchpriority="high">
												{% else -%}
													<img src="css/img/img-placeholder.jpg" alt="{{ product.Name }}" loading="eager" fetchpriority="high">
												{% endif -%}
											</div>
											<span>{{ translations.Set | Capitalize }}</span>
										</a>

										<a href="{{ page.BaseHref }}{{ product.Url }}" title="{{ translations.Set | Capitalize }}" class="header-cart__list-column mobile-link">{{ translations.Set | Capitalize }}</a>

										<div class="header-cart__list-column quantity-col">1</div>

										<div class="header-cart__list-column price">
											<span class="header-cart__column-text mobile">
												{{translations.Price}}
												{% if customer.Cart.SubtotalPrices -%}
													{{ translations.Netto | Downcase }}
												{% else -%}
													{{ translations.Brutto | Downcase }}
												{% endif -%}
											</span>
											<span>{{ setValue | ToPrice }} {{ customer.CurrencyExt.Symbol }}</span>
											{% if setDeposit > 0 -%}
												<span>+ {{ translations.Com_Deposit }}: {{ setDeposit | ToPrice }} {{ customer.CurrencyExt.Symbol }}</span>
											{% endif -%}
										</div>

										<div class="header-cart__list-column delete form-js no-message-js">
											<input type="hidden" name="__action" value="Cart/PositionDelete" >
											<input type="hidden" name="no" value="{{ product.No }}" >
											<input type="hidden" name="totalvalue" value="{{ product.TotalPrice | Times: product.Quantity }}" >
											<button class="header-inquiry-deleter-js remove-product-from-cart-js {% if inquiryProductsSize == setCounter -%} last-product-header-js {% endif -%}" title="{{ translations.Delete }}" data-item-number="{{ product.No }}">
												<svg>
													<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#trash-alt-{{settings.iconStyle}}"></use>
												</svg>
										</div>
									</div>
								{% endif -%}

								<div class="header-cart__list-row set-element setElement-js" data-number="{{product.No}}" data-id="{{product.Id}}" data-name="{{ product.NameNoHtml | H }}" data-price="{{ product.TotalPrice }}">
										<a href="{{ page.BaseHref }}{{ product.Url }}" title="{{ product.NameNoHtml | H }}" class="header-cart__list-column product">
											<div class="header-cart__list-image">
												{% if product.Image.Id > 0 and product.Image.Link != null -%}
													<img src="css/img/alo.gif" data-src="img/{{ product.Image.Id }}/{{ product.Image.Link }}" alt="{{ product.Name }}">
												{% elsif product.Image.ExternalUrl != null -%}
													<img src="css/img/alo.gif" data-src="{{ product.Image.ExternalUrl }}" alt="{{ product.Name }}">
												{% else -%}
													<img src="css/img/alo.gif" data-src="css/img/img-placeholder.jpg" alt="{{ product.Name }}">
												{% endif -%}
											</div>
											<span>{{ product.NameNoHtml | H }}</span>
										</a>

										<a href="{{ page.BaseHref }}{{ product.Url }}" title="{{ product.NameNoHtml | H }}" class="header-cart__list-column mobile-link">{{ product.NameNoHtml | H }}</a>
				
										<div class="header-cart__list-column quantity-col"></div>
					
										<div class="header-cart__list-column price">
											<span class="header-cart__column-text mobile">
												{{translations.Price}}
												{% if customer.Cart.SubtotalPrices -%}
													{{ translations.Netto | Downcase }}
												{% else -%}
													{{ translations.Brutto | Downcase }}
												{% endif -%}
											</span>
											<span>
												{% if config.ENTERPRISE -%}
													{% if product.TotalPrice == 0 -%}
														{{translations.Free | Upcase}}
													{% else -%}
														{{ product.TotalPrice | ToPrice }} {{ customer.CurrencyExt.Symbol }}
													{% endif -%}
												{% else -%}
													{% if product.Price == 0 -%}
														{{translations.Free | Upcase}}
													{% else -%}
														{{ product.Price | ToPrice }} {{ customer.CurrencyExt.Symbol }}
													{% endif -%}
												{% endif -%}
											</span>
											{% if product.DepositValue > 0 -%}
												<span>+ {{ translations.Com_Deposit }}: {{ product.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ customer.CurrencyExt.Symbol }} / {{ productUnits }}</span>
											{% endif -%}
										</div>
								</div>
						{% else -%}
							<div class="header-cart__list-row form-js header-cart-product-js" data-number="{{ product.No }}" data-id="{{ product.Id }}" data-name="{{ product.NameNoHtml | H }}" data-price="{{ product.Price }}">
								<a href="{{ page.BaseHref }}{{ product.Url }}" title="{{ product.NameNoHtml | H }}" class="header-cart__list-column product">
									<div class="header-cart__list-image">
										{% if product.Image.Id > 0 and product.Image.Link != null -%}
											<img src="css/img/alo.gif" data-src="img/{{ product.Image.Id }}/{{ product.Image.Link }}" alt="{{ product.Name }}">
										{% elsif product.Image.ExternalUrl != null -%}
											<img src="css/img/alo.gif" data-src="{{ product.Image.ExternalUrl }}" alt="{{ product.Name }}">
										{% else -%}
											<img src="css/img/alo.gif" data-src="css/img/img-placeholder.jpg" alt="{{ product.Name }}">
										{% endif -%}
									</div>
									<span>{{ product.NameNoHtml | H }}</span>
								</a>

								<a href="{{ page.BaseHref }}{{ product.Url }}" title="{{ product.NameNoHtml | H }}" class="header-cart__list-column mobile-link">{{ product.NameNoHtml | H }}</a>

								<div class="header-cart__list-column quantity-col form-js no-message-js change-quantity-in-cart-js">
									<input type="hidden" name="__action" value="Cart/QuantityChange" >
									<input type="hidden" name="no" value="{{ product.No }}" >
									<input type="hidden" name="isFromHeader" value="true">
									{% capture lastQuantityAttr -%} data-last-proper-quantity="{{ product.Quantity | Normalize }}" {% endcapture -%}


									{% assign inputValue = product.Quantity | Normalize -%}
									{% if config.Products.DecimalUnits -%}
										{% assign inputValueArray = inputValue | ToString | Split: config.DecimalSeparator -%}
										{% assign inputValueArraySize = inputValueArray | Size -%}
										{% if inputValueArraySize > 1 -%}
											{% assign decimalSize = inputValueArray[1] | Size -%}
											{% if decimalSize == 1 -%}
												{% capture inputValue -%}{{ inputValue }}0{% endcapture -%}
											{% endif -%}
										{% else -%}
											{% capture inputValue -%}{{ inputValue }}{{ config.DecimalSeparator }}00{% endcapture -%}
										{% endif -%}
									{% endif -%}

									{% if product.Multiplicity > 0 -%}
										{% assign unitMultiplicity = product.Multiplicity -%}
									{% else -%}
										{% assign unitMultiplicity = 0 -%}
									{% endif -%}
									<div class="header-cart__list-column-row">
										<div class="header-cart__quantity">
											<button aria-label="{{ translations.DecreaseQuantity }}" class="no-delay change-quantity-js change-quantity-header decrement-js header-cart__quantity-minus" {% if product.Quantity <= 1 -%} disabled {% endif -%}>
												<svg>
													<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#minus-{{settings.iconStyle}}"></use>
												</svg>
											</button>
											<input aria-label="{{ translations.ChangeQuantity }}" class="no-delay change-quantity-header-input {% if product.IsEdited != null and complaintOrReturn == false -%} order-editing-quantity-js {% endif -%}" type="text" name="quantity" value="{{inputValue}}" data-min="{{min}}" data-max="{{ max }}" {% if minQ -%} data-minq="{{minQ}}" {% endif -%} {% if unitMultiplicity > 0 -%} data-multiplicity="{{unitMultiplicity}}" {% endif -%} data-name="{{product.NameNoHtml | H}}" data-no="{{product.No}}" data-price-number="{% if totalPrice -%}{{totalPrice}}{% elseif price -%}{{price}}{% else -%}{{product.Price}}{% endif -%}" data-price="{{ product.Price | ToPrice }}" {{lastQuantityAttr}}>
											<button aria-label="{{ translations.IncreaseQuantity }}" class="no-delay change-quantity-js change-quantity-header increment-js header-cart__quantity-plus">
												<svg>
													<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#plus-{{settings.iconStyle}}"></use>
												</svg>
											</button>		
										</div>
										{% if product.SaleUnit -%}
											<span class="header-cart__quantity-unit">{{product.SaleUnit}}</span>
										{% endif -%}
									</div>
									
									{% if unitMultiplicity > 0 -%}
										<div class="header-cart__column-row">
											<div class="multiplicity-info-js">{{ translations.Multiplicity }} <span class="multiplicity-js">{{ unitMultiplicity }}</span> <span class="name-js">{{ unitName }}</span></div>
										</div>
									{% endif -%}
								</div>

								<div class="header-cart__list-column price">
									<span class="header-cart__column-text mobile">
										{{translations.Price}}
										{% if customer.Cart.SubtotalPrices -%}
											{{ translations.Netto | Downcase }}
										{% else -%}
											{{ translations.Brutto | Downcase }}
										{% endif -%}
									</span>
									<span>{{ product.Price | Round: config.DecimalPlacesPrice | ToPrice }} {{ customer.CurrencyExt.Symbol }}</span>
									{% if product.DepositValue > 0 -%}
										<span>+ {{ translations.Com_Deposit }}: {{ product.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ customer.CurrencyExt.Symbol }} / {{ productUnits }}</span>
									{% endif -%}
								</div>

								<div class="header-cart__list-column delete form-js no-message-js">
									<input type="hidden" name="__action" value="Cart/PositionDelete" >
									<input type="hidden" name="no" value="{{ product.No }}" >
									<input type="hidden" name="totalvalue" value="{{ product.TotalPrice | Times: product.Quantity }}" >
									<button class="header-inquiry-deleter-js remove-product-from-cart-js {% if inquiryProductsSize == 1 -%} last-product-header-js {% endif -%}" title="{{ translations.Delete }}" data-id="{{product.Id}}" data-name="{{ product.NameNoHtml | H }}" data-price="{{ product.TotalPrice }}" data-item-number="{{ product.No }}">
										<svg>
											<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#trash-alt-{{settings.iconStyle}}"></use>
										</svg>
									</button>
								</div>
							</div>
						{% endif -%}
					{% endfor -%}
				</div>
				<div class="header-cart__summary">
                    <button class="header-cart__summary-btn primary-action-button load-inquiry-js" data-choice="goToCart" data-url="{{ page.BaseHref }}{{ config.DefinedPages.Order.Url }}?add-inquiry=true" data-inquiry-id="">
                        {{translations.GoToInquiry}}
					</button>
				</div>
			{% else -%}
				<div class="header-cart__empty">
					<svg class="header-cart__empty-img">
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#file-invoice-dollar-{{settings.iconStyle}}"></use>
					</svg>
					<div class="header-cart__empty-text">{{translations.EmptyInquiry}}</div>
				</div>
			{% endif -%}
		</div>
    </div>
</div>
`